import {
  BULK_INVITE_ASSIGNABLE_ROLES,
  DEFAULT_IMPORT_ROLE,
} from 'src/app/BulkInvite/bulkInvite.constants'
import { BulkInviteAssignableRole } from 'src/app/BulkInvite/bulkInvite.types'
import { OrganizationRoles } from 'src/enums'
import { orgRoleDisplayTitle } from 'src/utils/roles.utils'

interface BulkInviteRoleAvailability {
  canInviteAdmin?: boolean
  cardManagerRoleEnabled?: boolean
}

export function getAvailableBulkInviteRoles({
  canInviteAdmin,
  cardManagerRoleEnabled,
}: BulkInviteRoleAvailability): BulkInviteAssignableRole[] {
  const roles: BulkInviteAssignableRole[] = [
    OrganizationRoles.member,
    OrganizationRoles.bookkeeper,
  ]

  if (cardManagerRoleEnabled) {
    roles.push(OrganizationRoles.cardManager)
  }

  if (canInviteAdmin) {
    roles.push(OrganizationRoles.admin)
  }

  return roles
}

export function isBulkInviteAssignableRole(
  role: string | null | undefined,
): role is BulkInviteAssignableRole {
  return BULK_INVITE_ASSIGNABLE_ROLES.includes(role as BulkInviteAssignableRole)
}

export function coerceBulkInviteRole(
  role: string | null | undefined,
  availableRoles: BulkInviteAssignableRole[],
): BulkInviteAssignableRole {
  if (
    isBulkInviteAssignableRole(role) &&
    availableRoles.includes(role as BulkInviteAssignableRole)
  ) {
    return role
  }
  return DEFAULT_IMPORT_ROLE
}

export function bulkInviteRoleLabel(role: BulkInviteAssignableRole): string {
  return orgRoleDisplayTitle(role)
}
